/* @flow */

export type MaskableType = 'email' | 'string';

export const maskable = (
  text: string,
  type: MaskableType = 'string',
  shouldMask: boolean = true,
  maskChar: string = '*'
) => {
  if (!shouldMask) {
    return text;
  }

  switch (type) {
    case 'email':
      const [, first, domain, tlDomain] = /(.*)@(.*)\.(.*)$/.exec(text);

      return `${first.substr(0, 1)}${Array(5)
        .fill(maskChar)
        .join('')}${domain ? '@' : ''}${
        domain
          ? Array(5)
              .fill(maskChar)
              .join('')
          : ''
      }${tlDomain ? `.${tlDomain}` : ''}`;

    default:
    case 'string':
      return Array(5)
        .fill(maskChar)
        .join('');
  }
};
